import { Sun } from "lucide-react";
import { MARQUEE } from "@/lib/content";

const Row = ({ hidden }) => (
  <div className="flex items-center shrink-0" aria-hidden={hidden}>
    {MARQUEE.map((t, i) => (
      <span key={t} className="flex items-center">
        <span className={`font-display font-black uppercase text-5xl sm:text-6xl lg:text-7xl px-8 whitespace-nowrap ${i % 2 ? "text-outline" : "text-white"}`}>{t}</span>
        <Sun className="text-[var(--sun)] shrink-0" size={36} strokeWidth={2.5} />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="editorial-marquee" className="relative overflow-hidden border-y border-white/10 bg-[var(--navy)] py-8 lg:py-10">
    <div className="marquee-track">
      <Row />
      <Row hidden />
    </div>
  </section>
);
